import script from "./PerfBandLegend.vue?vue&type=script&setup=true&lang=ts"
export * from "./PerfBandLegend.vue?vue&type=script&setup=true&lang=ts"

import "./PerfBandLegend.vue?vue&type=style&index=0&id=462802e9&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_vue@3.4.38_typescript@5.9.3__webpack@5.98.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-462802e9"]])

export default __exports__